import { css } from '@emotion/react';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import t from 'react-translate';
import NvIcon from 'shared/components/nv-icon';
import { AngularContext } from 'react-app';
import { getCurrentUser } from 'redux/selectors/users';
import { FullCourse } from 'redux/schemas/models/courseFull';
import { hexToRgbaString } from 'styles/global_defaults/colors';
import { OfferingContext } from 'offerings/components/offering-card';
import { openSans } from 'styles/global_defaults/fonts';
import { useAppDispatch } from 'redux/store';
import { setShowCourseCompletionStatusModal } from 'redux/actions/courses';


type Props = {
  className?: string,
  style?: React.CSSProperties,
};

const CompletedStatusOverlay = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    style,
    className,
  } = props;

  const dispatch = useAppDispatch();
  const currentUser = useSelector(getCurrentUser);
  const offering = useContext(OfferingContext);
  const { injectServices } = useContext(AngularContext);
  const [$state] = injectServices(['$state']);

  const styles = css`
    & > div {
      border: 1px solid ${hexToRgbaString('#fff', 0.6)};
    }

    .info {
      font-family: ${openSans};
      max-width: 98%;
    }
  `;

  const hasCertificate = (offering as unknown as FullCourse).soaCertificateEnabled;

  const handleCertificateOnClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation();

    // If user was viewing the course completion status modal, we need to close it
    dispatch(setShowCourseCompletionStatusModal(false));

    window.location.href = $state.href(offering.isJourney ? 'journey-statement-modal' : 'statement-modal', {
      userId: currentUser.id,
      catalogId: offering.catalogId,
    });
  };

  return (
    <div
      ref={ref}
      css={styles}
      style={style}
      className={`color-white p-2 ${className ? `${className}` : ''}`}
    >
      <div className='h-100 w-100 d-flex flex-column justify-content-center align-items-center text-align-center'>
        {hasCertificate ? (
          <a className='info color-white text-medium font-weight-bolder' onClick={handleCertificateOnClick}>
            <NvIcon
              icon='badge'
              size='medium'
              className='mb-2'
            />
            <span className='two-line-ellipsis'>
              {t.OFFERINGS.CARD.VIEW_CERTIFICATE(offering?.certificateName?.singularizedTitleized ?? t.OFFERINGS.CARD.CERTIFICATE())}
            </span>
          </a>
        ) : (
          <div className='info color-white text-medium font-weight-bolder'>{t.OFFERINGS.CARD.CONGRATULATIONS()}</div>
        )}
      </div>
    </div>
  );
});

export default CompletedStatusOverlay;
